module.exports = __webpack_public_path__ + "static/img/oogatabae_rui.aa0a62c.jpg";